import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import StrongholdShopInfoItem from './StrongholdShopInfoItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'

const StrongholdShopInfoItemEditable = EditableHOCWrapper(StrongholdShopInfoItem)

class StrongholdShopInfo extends PureComponent {
  render() {
    const { shopsList = {}, achList = {}, onSave, lastModified, onDelete } = this.props
    const { values = [] } = shopsList

    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            <div className="table-scroll">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Shop Name</TableCell>
                    <TableCell>Api key</TableCell>
                    <TableCell>Environment</TableCell>
                    <TableCell>Tipping</TableCell>
                    <TableCell>Capturing</TableCell>
                    <TableCell>Ignore BLAZE ECOM</TableCell>
                    <TableCell>Status</TableCell>
                    {hasAccess() ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(values &&
                    values.length &&
                    values.map((shop, index) => {
                      return (
                        <StrongholdShopInfoItemEditable
                          key={index}
                          dataToEdit={achList[shop.id]}
                          isNotLinkedApiKey={
                            achList[shop.id] && achList[shop.id].apiKey ? false : true
                          }
                          onSave={onSave}
                          lastModified={lastModified}
                          shop={shop}
                          onDelete={onDelete}
                        />
                      )
                    })) ||
                    null}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </div>
    )
  }
}

export default StrongholdShopInfo



// WEBPACK FOOTER //
// ./src/components/Stronghold/StrongholdShopInfo.js